/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 *
 * @format
 */

import { Inject, Injectable } from "@angular/core";
import { Logger } from "@html-core";
import { WindowToken } from "../../shared/common/window.module";
import { JscdkCommonInvoker } from "../../shared/common/jscdk/jscdk-common-invoker";

@Injectable({
   providedIn: "any"
})
export class ActiveClientService {
   private activeClient: ActiveClient | null = null;

   constructor(
      @Inject(WindowToken) private window: Window,
      private jscdkCommonInvoker: JscdkCommonInvoker
   ) {
      if (!this.window.chromeClient) {
         this.window.chromeClient = {};
      }
   }

   public getActiveClient(): ActiveClient | null {
      return this.activeClient;
   }

   public init() {
      // The SDK control would reset the active client, and this is only used for URL for now.
      // TODO: merge both in the long term
      if (
         typeof this.window.chromeClient.setActiveClient === "function" &&
         typeof this.window.chromeClient.clearActiveClient === "function"
      ) {
         Logger.info("skip link the URL active control to client, since it is already linked for SDK");
         return;
      }

      Logger.info("link the URL active control to client for normal cases");
      this.window.chromeClient.setActiveClient = this.setActiveClient.bind(this);
      this.window.chromeClient.clearActiveClient = this.clearActiveClient.bind(this);
   }

   private setActiveClient(activeClient: ActiveClient) {
      const { isReusable, serverAddress, xmlServerURL, operations, client } = activeClient;
      Logger.info("setting active client");

      if (!client || !serverAddress || !xmlServerURL || typeof isReusable !== "boolean") {
         Logger.error("invalid active client");
         return;
      }

      if (isReusable && (!operations || typeof operations.launchItem !== "function")) {
         Logger.error("invalid reusable client");
         return;
      }

      this.activeClient = activeClient;
      Logger.log("active client had been set for server: " + serverAddress);
   }

   private clearActiveClient(reasonString, logoutSession) {
      if (logoutSession) {
         this.logoutActiveClient();
      }

      if (!this.activeClient || !this.activeClient.client) {
         Logger.log("no active client to be reset for " + reasonString);
         return;
      }

      Logger.log("resetting active client for " + reasonString);
      this.activeClient = null;
   }

   private logoutActiveClient() {
      if (!this.activeClient || !this.activeClient.xmlServerURL) {
         Logger.log("no active client need to be logout");
         return;
      }

      if (
         typeof this.activeClient.serverAddress !== "string" ||
         typeof this.activeClient.xmlServerURL !== "string" ||
         !this.activeClient.xmlServerURL.startsWith("https://")
      ) {
         Logger.error(
            "invalid server address" + this.activeClient.serverAddress + ", " + this.activeClient.xmlServerURL
         );
         return;
      }

      Logger.log("logout client form server: " + this.activeClient.serverAddress);
      setTimeout(() => this.jscdkCommonInvoker.logout());
   }
}
